import React, { useContext, useState } from 'react';
import { Form, Col, Alert, Tabs, Tab } from 'react-bootstrap';
import { Formik } from 'formik';
import * as Yup from "yup";
import api from '../../../api';
import { ModalContext } from '../../../contexts/modal';
import { trackPromise } from 'react-promise-tracker';
import RichGooglePlacesAutoComplete from "../../../autocomplete/RichGooglePlacesAutoComplete";

const FormBuyerCompany = ({ onFormSubmit, id, userType }) => {
    const { handleModalClose, onSubmitButtonHide } = useContext(ModalContext);
    const [alert, setAlert] = useState(false);
    const [tabKey, setTabKey] = useState('signup-options');
    const [showPasword, setShowPassword] = useState(false);
    const [showConfirmPasword, setShowConfirmPasword] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');


    // Company Name, company email, mobile number, city, area, company license number, land line, at least 2 contact details
    const validSchema = Yup.object().shape({
        companyName: Yup.string().required("Required"),
        email: Yup.string().email().required("Required"),
        // password: Yup.string()
        //     .min(8, "Your password must be at least 8 characters long").max(100, "Too long")
        //     .required("Required")
        //     .matches(
        //         /^(?=.*[a-z])(?=.*[@$!%*#?&])(?=.*[0-9]).*$/,
        //         "Must contain at least 1 lowercase character, 1 number, 1 special character"
        //     ),
        password: Yup.string().required("Required").min(8, "Your password must be at least 8 characters long"),
        conPassword: Yup.string().required('required').oneOf([Yup.ref("password"), null], "Passwords must match").min(8, "Confirm password must be at least 8 characters long"),

        cellNumber: Yup.string().required("Required").max(11, 'Phone must contain 11 numbers').min(11, 'Phone must contain 11 numbers'),
        city: Yup.string().required("Required"),
        // area: Yup.string().required("Required"),
        companyLicenceNumber: Yup.string(),
        landLine: Yup.string()
    })

    // const onSubmit = async (values) => {

    //     console.log("values", values);

    //     await api.post("/auth/signup", {
    //         ...values
    //     })
    //     handleModalClose()


    // }
    const handleShowPassword = () => {
        showPasword ? setShowPassword(false) : setShowPassword(true)
    }

    const handleShowConfirmPassword = () => {
        showConfirmPasword ? setShowConfirmPasword(false) : setShowConfirmPasword(true)
    }
    async function onSubmit(values) {
        try {
            await api.post("/auth/signup", {
                ...values,
                userType,
                role: 'user'
            });
            // handleModalClose();
            setTabKey('message')
            onSubmitButtonHide();
        } catch (error) {
            setAlert(true);
            setAlertMessage(error.response.data.message)
        }

    };

    return (
        <Tabs
            defaultActiveKey={tabKey}
            transition={false}
            id="noanim-tab-example"
            className="my-tabs"
        >
            <Tab eventKey="signup-options" title="" active={tabKey === "signup-options" ? true : false} >
                <Formik
                    onSubmit={(values) => trackPromise(onSubmit(values), 'register')}
                    validationSchema={validSchema}
                    enableReinitialize
                    initialValues={{
                        companyName: '',
                        email: '',
                        cellNumber: '',
                        city: '',
                        area: '',
                        companyLicenceNumber: '',
                        landLine: '',
                        password: '',
                        conPassword: ''
                    }}
                >
                    {(formik) => (
                        <Form
                            onSubmit={formik.handleSubmit}
                            id={id}
                        >
                            {
                                alert ?
                                    <Alert variant="danger" className="rounded">{alertMessage}</Alert>
                                    : ""
                            }
                            <Form.Row>
                                <Form.Group controlId="companyName" as={Col} hasValidation>
                                    <Form.Label className="form__label">Company Name</Form.Label>
                                    <Form.Control
                                        className="p-3 rounded-0"
                                        type="text"
                                        name="companyName"
                                        placeholder="Enter Company Name"
                                        value={formik.values.companyName}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        isValid={formik.touched.companyName && !formik.errors.companyName}
                                        isInvalid={formik.touched.companyName && formik.errors.companyName}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {formik.errors.companyName}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group controlId="email" as={Col} hasValidation>
                                    <Form.Label className="form__label">Email</Form.Label>
                                    <Form.Control
                                        className="p-3 rounded-0"
                                        type="email"
                                        name="email"
                                        placeholder="Enter Email"
                                        value={formik.values.email}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        isValid={formik.touched.email && !formik.errors.email}
                                        isInvalid={formik.touched.email && formik.errors.email}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {formik.errors.email}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Form.Row>

                            <Form.Row>
                                <Form.Group controlId="cellNumber" as={Col} hasValidation>
                                    <Form.Label className="form__label">Mobile</Form.Label>
                                    <Form.Control
                                        className="p-3 rounded-0"
                                        type="text"
                                        name="cellNumber"
                                        placeholder="03xxxxxxxxx"
                                        value={formik.values.cellNumber}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        isValid={formik.touched.cellNumber && !formik.errors.cellNumber}
                                        isInvalid={formik.touched.cellNumber && formik.errors.cellNumber}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {formik.errors.cellNumber}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group controlId="city" as={Col} hasValidation>
                                    <Form.Label className="form__label">City</Form.Label>
                                    {/* <Form.Control
                                        className="p-3 rounded-0"
                                        type="city"
                                        name="city"
                                        placeholder="Enter City"
                                        value={formik.values.city}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        isValid={formik.touched.city && !formik.errors.city}
                                        isInvalid={formik.touched.city && formik.errors.city}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {formik.errors.city}
                                    </Form.Control.Feedback> */}

                                    <RichGooglePlacesAutoComplete defaultValue={formik.values.area} placeholder="  City" onLocationSelect={({ description }) => {
                                        formik.setFieldValue('city', description);
                                        // this.setState({ area: description })
                                    }} />
                                </Form.Group>

                            </Form.Row>

                            <Form.Row>
                                {/* <Form.Group controlId="area" as={Col} hasValidation>
                                    <Form.Label className="form__label">Area</Form.Label> */}
                                {/* <Form.Control
                                        className="p-3 rounded-0"
                                        type="text"
                                        name="area"
                                        placeholder="Enter Area"
                                        value={formik.values.area}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        isValid={formik.touched.area && !formik.errors.area}
                                        isInvalid={formik.touched.area && formik.errors.area}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {formik.errors.area}
                                    </Form.Control.Feedback> */}
                                {/* <RichGooglePlacesAutoComplete defaultValue={formik.values.area} placeholder="  Area" onLocationSelect={({ description }) => {
                                        formik.setFieldValue('area', description);
                                        // this.setState({ area: description })
                                    }} />
                                </Form.Group> */}

                                <Form.Group controlId="companyLicenceNumber" as={Col} hasValidation>
                                    <Form.Label className="form__label">Company Licence Number</Form.Label>
                                    <Form.Control
                                        className="p-3 rounded-0"
                                        type="number"
                                        name="companyLicenceNumber"
                                        placeholder="Enter Company Licence Number"
                                        value={formik.values.companyLicenceNumber}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        isValid={formik.touched.companyLicenceNumber && !formik.errors.companyLicenceNumber}
                                        isInvalid={formik.touched.companyLicenceNumber && formik.errors.companyLicenceNumber}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {formik.errors.companyLicenceNumber}
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group controlId="landLine" as={Col} hasValidation>
                                    <Form.Label className="form__label">Land Line</Form.Label>
                                    <Form.Control
                                        className="p-3 rounded-0"
                                        type="number"
                                        name="landLine"
                                        placeholder="Enter Land Line"
                                        value={formik.values.landLine}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        isValid={formik.touched.landLine && !formik.errors.landLine}
                                        isInvalid={formik.touched.landLine && formik.errors.landLine}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {formik.errors.landLine}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Form.Row>

                            <Form.Row>
                                <Form.Group controlId="password" as={Col} hasValidation>
                                    <Form.Label className="form__label">Password</Form.Label>
                                    <div style={{ position: "relative", display: "flex" }}>
                                        <Form.Control
                                            className="p-3 rounded-0 "
                                            // style={{backG}}
                                            type={showPasword ? "text" : "password"}
                                            name="password"
                                            autoComplete="new-password"
                                            style={{ backgroundImage: 'none' }}
                                            placeholder="Please Enter Your Password"
                                            value={formik.values.password}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            isValid={formik.touched.password && !formik.errors.password}
                                            isInvalid={formik.touched.password && formik.errors.password}
                                        />
                                        {

                                            showPasword ?
                                                <i class="fas fa-eye-slash" style={{ color: "black", cursor: "pointer", position: "absolute", right: "2%", marginTop: "0.7rem" }} onClick={() => {
                                                    console.log("password show")
                                                    handleShowPassword()
                                                }}></i>
                                                :
                                                <i class="far fa-eye" style={{ color: "black", cursor: "pointer", position: "absolute", right: "2%", marginTop: "0.7rem" }} onClick={() => {
                                                    console.log("password show")
                                                    handleShowPassword()
                                                }} ></i>
                                        }
                                    </div>
                                    <Form.Control.Feedback style={{ display: "block" }} type="invalid">
                                        {formik.errors.password}
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group controlId="conPassword" as={Col} hasValidation>
                                    <Form.Label className="form__label">Confirm Password</Form.Label>
                                    <div style={{ position: "relative", display: "flex" }}>
                                        <Form.Control
                                            className="p-3 rounded-0"
                                            type={showConfirmPasword ? "text" : "password"}
                                            name="conPassword"
                                            placeholder="Please Enter Confirm Password"
                                            value={formik.values.conPassword}
                                            style={{ backgroundImage: 'none' }}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            isValid={formik.touched.conPassword && !formik.errors.conPassword}
                                            isInvalid={formik.touched.conPassword && formik.errors.conPassword}
                                        />
                                        {

                                            showConfirmPasword ?
                                                <i class="fas fa-eye-slash" style={{ color: "black", cursor: "pointer", position: "absolute", right: "2%", marginTop: "0.7rem" }} onClick={() => {
                                                    console.log("password show")
                                                    handleShowConfirmPassword()
                                                }}></i>
                                                :
                                                <i class="far fa-eye" style={{ color: "black", cursor: "pointer", position: "absolute", right: "2%", marginTop: "0.7rem" }} onClick={() => {
                                                    console.log("password show")
                                                    handleShowConfirmPassword()
                                                }} ></i>
                                        }
                                    </div>

                                    <Form.Control.Feedback style={{ display: "block" }} type="invalid">
                                        {formik.errors.conPassword}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Form.Row>
                        </Form>
                    )}
                </Formik>
            </Tab>
            <Tab eventKey="message" title="" active={tabKey === "message" ? true : false}>
                <div style={{ textAlign: 'center' }}>
                    <span style={{ fontSize: '20px', lineHeight: '1.8' }}>
                        <h4>Welcome to Subka Faida.</h4>
                        <span>
                            Thank you for signing up Subka Faida community. <br />
                            We have received your details and really appreciate for your time. <br />
                            Soon One of our representative will be in contact with you. <br />
                            Keep in touch with subka faida  for updates.
                        </span>
                    </span>
                </div>
            </Tab>
        </Tabs>

    )
}

export default FormBuyerCompany;